import script from "./Layout.vue?vue&type=script&setup=true&lang=js"
export * from "./Layout.vue?vue&type=script&setup=true&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=c6352ef8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6352ef8"]])

export default __exports__